import { useEffect, useState } from 'react'
import { CampaignOutlined, OpenInNew } from '@mui/icons-material'
import { useLocation } from 'react-router-dom'
import './academic-feedback-card.style.scss'

const FEEDBACK_CARD_STORAGE_KEY = 'to-focus:feedback-card-hidden'
const FEEDBACK_FORM_URL = 'https://forms.gle/1rnxUbcVSvyVroV3A'

const AcademicFeedbackCard = () => {
  const location = useLocation()
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    const isHidden =
      window.localStorage.getItem(FEEDBACK_CARD_STORAGE_KEY) === 'true'

    setIsVisible(!isHidden)
  }, [])

  if (!isVisible || location.pathname !== '/') {
    return null
  }

  return (
    <aside className="academic-feedback-card">
      <div className="academic-feedback-card__icon">
        <CampaignOutlined />
      </div>

      <div className="academic-feedback-card__content">
        <strong>{'Sua opini\u00e3o faz diferen\u00e7a'}</strong>
        <p>
          {
            'O To Focus faz parte de uma pesquisa acad\u00eamica. Se puder responder o formul\u00e1rio, j\u00e1 ajuda muito a evoluir o projeto.'
          }
        </p>
      </div>

      <a
        className="academic-feedback-card__link"
        href={FEEDBACK_FORM_URL}
        target="_blank"
        rel="noopener noreferrer"
      >
        {'Quero ajudar'}
        <OpenInNew fontSize="inherit" />
      </a>
    </aside>
  )
}

export { AcademicFeedbackCard, FEEDBACK_FORM_URL }
